export const getResultValue = (element: any, valuePath: string[]) => {
  let value = element;
  if (valuePath) {
    valuePath.forEach(v => {
      value = value?.[v];
    });
  }
  return value;
};

export const getResultValues = (element: any, valuePaths: string[][]) => {
  let value = element;
  let pathResults: any[] = [];
  valuePaths.forEach(valuePath => {
    pathResults.push(value);
    valuePath.forEach(v => {
      pathResults[pathResults.length - 1] = pathResults[pathResults.length - 1]?.[v];
    });
  });
  return pathResults;
};